import { ApolloLink, Observable } from "@apollo/client/core";
import { apmBase } from "@elastic/apm-rum";

/**
 * Apollo link that wraps each GraphQL operation in a named APM span.
 *
 * Without this, all GraphQL calls appear as a single "/graphql" span in Kibana.
 * With this link, each operation gets its own span: "GraphQL: GetCart",
 * "GraphQL: SearchProducts", etc.
 *
 * Should be the first link in the chain so it measures full operation time.
 */
export const apmLink = new ApolloLink((operation, forward) => {
  if (import.meta.env.APP_APM_ENABLED !== "true") {
    return forward(operation);
  }

  const name = operation.operationName || "anonymous";
  const span = apmBase.startSpan(`GraphQL: ${name}`, "graphql");

  return new Observable((observer) => {
    const sub = forward(operation).subscribe({
      next(value) {
        span?.end();
        observer.next(value);
      },
      error(err) {
        span?.end();
        observer.error(err);
      },
      complete() {
        observer.complete();
      },
    });
    return () => sub.unsubscribe();
  });
});
